import request from '../utils/request';
//var data = require("../default/data");
var jigsaw = {
  create: ({ galleryid, imageids }) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/usersplice/create',
        method: 'post',
        data: {
          galleryid,
          imageids
        },
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  //小图到大图
  show: ({ galleryid, imageids }) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/usersplice/show',
        method: 'post',
        data: {
          galleryid,
          imageids
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  }
};

export default jigsaw;
